<template>
  <div class="nav-bar">
    <div class="nav-bar-header">
      <div class="nav-bar-header-left">
        <a href="https://www.lojapecasoriginais.com.br/pt/">
          <img src="@/assets/w-b-c-logo.jpg" alt="Whirlpool" />
        </a>
      </div>
      <div class="navbar-header-right">
        <div class="nav-bar-header-title">BEM VINDO {{ customer.name }}</div>
        <div class="nav-bar-logout-button">
          <button class="logout-button">SAIR</button>
        </div>
      </div>
    </div>
    <h3 class="qa-title" v-if="isInQA">AMBIENTE DE HOMOLOGAÇÃO</h3>
    <h3 class="dev-title" v-if="isInDev">AMBIENTE DE DESENVOLVIMENTO</h3>
    <ul>
      <li
        class="nav-bar-item"
        @click="selectTab('return-request')"
        :class="{ active: selectedTab == 'return-request' }"
        alt="Solicitar Devolução"
      >
        <p>SOLICITAR DEVOLUÇÃO</p>
      </li>
      <li
        class="nav-bar-item"
        @click="selectTab('return-tracking')"
        :class="{ active: selectedTab == 'return-tracking' }"
        alt="Acompanhar devolução"
      >
        <p>ACOMPANHAR DEVOLUÇÃO</p>
      </li>
      <li
        class="nav-bar-item"
        @click="selectTab('schedule-collection')"
        :class="{ active: selectedTab == 'schedule-collection' }"
        alt="Agenda de Coleta"
      >
        <p>AGENDA DE COLETA</p>
      </li>
      <li
        class="nav-bar-item"
        @click="selectTab('return-policy')"
        :class="{ active: selectedTab == 'return-policy' }"
        alt="Política de Devolução"
      >
        <p>POLÍTICA DE DEVOLUÇÃO</p>
      </li>
    </ul>
  </div>
</template>

<script>
import { EventBus } from "@/eventHub";
import store from "@/store";

export default {
  name: "Navbar",
  data() {
    return {
      selectedTab: "return-request",
      customer: store.state.customer,
      isInQA: false,
      isInDev: false
    };
  },
  methods: {
    selectTab(tab) {
      EventBus.$emit("tabChanged", tab);
      this.selectedTab = tab;
    }
  },
  mounted() {
    this.userType = this.user.profile_type;
    if (process.env.NODE_ENV === "qa") {
      this.isInQA = true;
    } else if (process.env.NODE_ENV === "development") {
      this.isInDev = true;
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/_colors.scss";
$width: 1160px;

.nav-bar {
  position: relative;
  top: 0;
  color: $white;

  ul {
    display: flex;
    justify-content: flex-start;
    padding-left: 23.125%;
    align-items: center;
    background-color: #505050;
    list-style: none;
    height: 45px;
    margin-top: 0;
    border-bottom: 5px solid #f34f34;
  }
}

h3 {
  width: 100%;
  text-align: center;
  color: white;
}

.qa-title {
  background-color: green;
  padding: 10px;
  margin: 0 0 15px 0px;
}

.dev-title {
  background-color: #444444;
  padding: 10px;
}

.nav-bar-header {
  height: 132px;
  background-color: $white;
  color: $grey2;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 8px 23.125% 0 23.125%;

  img {
    width: 297px;
    height: 66px;
    margin-left: -17px;
  }
}

.nav-bar-item {
  position: relative;
  font-size: 12px;
  top: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 170px;
  height: 45.5px;

  &:hover {
    cursor: pointer;
    background-color: $grey3;
  }
}

.navbar-header-right {
  display: flex;

  .nav-bar-header-title {
    background-color: $orange1;
    color: $white;
    height: 15px;
    position: relative;
    top: 12px;
    margin-right: 10px;
    font-size: 12px;
    padding: 12px;
    display: flex;
    align-items: center;
  }

  .logout-button {
    width: 100px;
    height: 39px;
    position: relative;
    top: 12px;
    border: none;
    background-color: $grey1;
    font-size: 12px;
    color: $white;
    outline: none;

    &:hover {
      cursor: pointer;
    }

    &:active {
      outline: none;
    }
  }
}

.active {
  background-color: $orange1;

  &:hover {
    background-color: $orange1;
  }
}

@media screen and (max-width: 1024px) {
  .nav-bar-header {
    width: 544px;
  }
}
</style>
